<p *ngIf="isLoading" class="flex-center-center mb-0 p-2 font-14">
  <span>Loading</span>
  <i class="fal fa-spinner rotate ml-2"></i>
</p>

<app-unsubscribe-contact *ngIf="!isLoading && !isMarketingOptOutEnabled" [isPassingData]="true" [data]="data">
</app-unsubscribe-contact>

<div *ngIf="!isLoading && isMarketingOptOutEnabled"
  class="appt-verify-body customer-font-{{company?.appsettings?.customerPreviewFontSize}}">
  <div class="verfication-card">
    <div class="appt-preview-header level-1-bg">
      <div class="header-wrapper level-1" [ngClass]="company?.name?.length >= 74 ? 'long-character-name' : ''">
        <div class="logo">
          <div class="logo-placehonder verticalWrapper">
            <div class="verticalCenter">
              <div class="company-presence">
                <div class="logoImgWrapper">
                  <img [src]="company.logo" *ngIf="company.logo" class="img-fluid">
                </div>
                <div class="logo-title">
                  {{'unsubscribe.preferences'|translate}}
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="communication">
          <div class="icon-box verticalWrapper">
            <div class="globe-icon" (click)="toggleLanguageDropdown()" *ngIf="companyLocalization">
              <i class="fa fa-globe fa-globe" aria-hidden="true"></i>
              <span class="lang">
                {{currentLang?.toUpperCase()}}
              </span>
              <div *ngIf="isLanguageDropdownVisible" class="language-dropdown">
                <div (click)="switchLanguage('en')">
                  English
                </div>
                <div (click)="switchLanguage('fr')">
                  French (Français)
                </div>
              </div>
            </div>
            <div class="verticalCenter">
              <a class="order-action" [href]="'tel:'+ company.phone">
                <i class="fal fa-phone-alt font-16 mr-15 pointer" tooltipPosition="top"
                  [pTooltip]="company.phone | mask: '(000) 000-0000'"></i>
              </a>

              <a class="order-action" [href]="'mailto:'+ company.email">
                <i class="fal fa-envelope font-16 pointer"></i>
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="verfication-card-body flex-column flex-start-start">
      <div class="verfication-card-body-content">
        <p class="font-bold font-12 font-secondary-900 mb-2 mt-2">
          {{'unsubscribe.manage'|translate}} {{contact?.contactType === 'email'? 'email' : 'SMS'}}
          {{'unsubscribe.subscriptions-for'|translate}}
          {{contact?.contactType === 'email'? contact?.contactValue: contact?.contactValue | mask: '(000) 000-0000'}}
        </p>
      </div>

      <div class="set-toggles">
        <div class="ui-g-12 p-0 mt-1">
          <div class="flex-start-center">
            <app-switch-pill position="end" [fontSize]="14" [isActive]="contact.isMarketingNotifEnabled"
              styleClassLabel="font-black" label="{{'unsubscribe.marketing-notifications'|translate}}"
              (appChange)="handleAppSettingChange('isMarketingNotifEnabled', $event)">
            </app-switch-pill>
          </div>

          <p class="marketing-text">
            {{'unsubscribe.this-includes-promotions-discounts-and-important-follow-up-reminders'|translate}}
          </p>
        </div>
      </div>

      <div class="set-toggles">
        <div class="ui-g-12 p-0 mt-1">
          <div class="flex-start-center">
            <app-switch-pill position="end" [fontSize]="14" [isActive]="contact.isOperationalNotifEnabled"
              styleClassLabel="font-black" label="{{'unsubscribe.operational-reminders'|translate}}"
              (appChange)="handleAppSettingChange('isOperationalNotifEnabled', $event)">
            </app-switch-pill>
          </div>

          <p class="marketing-text">
            {{'unsubscribe.these-are-important-reminders-for-appointments-estimates-and-review-requests'|translate}}
          </p>

          <p *ngIf="!emailSubscriptionFlags.isOperationalNotifEnabled" class="marketing-alert">
            <i class="fal fa-exclamation-triangle font-yellow"></i>
            <span>
              {{'unsubscribe.you-might-miss-out-important-notifications-about-your-repair-order'|translate}}
            </span>
          </p>
        </div>
      </div>

      <div class="set-toggles">
        <div class="ui-g-12 p-0 mt-3">
          <div class="flex-start-center">
            <button class="btn btn-primary btn-submit" [disabled]="unSubscribing" (click)="onSubmit()">
              {{'unsubscribe.save-preferences'|translate}}
              <i *ngIf="unSubscribing" class="fal fa-spinner rotate ml-2"></i>
            </button>
          </div>
        </div>
      </div>
    </div>

    <div class="ui-g verfication-notes-body">
      <div class="verfication-notes-body-content pr-2 pl-2">
        <div class="ui-g-12 pt-2 pt-2 pl-2 pb-0 b-bottom">
          <p class="font-bold font-12 mt-1 mb-2">{{'notes'|translate}}</p>
        </div>

        <div class="ui-g-12 p-2">
          <p class="contact-text">
            {{'unsubscribe.for-further-assistance-please-contact-us-at'|translate}}&nbsp;<span class="contact-details">
              {{company?.phone | mask: '(000) 000-0000' }}</span>
            {{'unsubscribe.or-write-us-an-email-at'|translate}}&nbsp;<span
              class="contact-details">{{company?.email}}</span>
          </p>
        </div>
      </div>
    </div>

    <div class="verificaton-footer flex-column flex-center-center dynamicFont">
      <p class="m-0 text-center">&copy; {{company.name}}, {{year}}. {{'unsubscribe.all-rights-reserved'|translate}}</p>
      <p class="m-0 text-center">{{'unsubscribe.powered-by'|translate}} <a class="website-link"
          href="http://autoleap.com/">AutoLeap</a> </p>
    </div>
  </div>
</div>